<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 comment-section">
  <div class="ui-g-12 comment-section-title mt-3">{{ 'documents.comment' | translate }}</div>
  <ng-container>
    <quill-editor
      [styles]="editorStyle"
      placeholder="Enter Text"
      [(ngModel)]="comment"
      (ngModelChange)="commentChange.emit($event)"
      [disabled]="!(canEdit$ | async)"
      name="comment"
      [modules]="quillConfig"></quill-editor>
  </ng-container>
</div>
